/**
 * Fair Home V2 — H11 page scroll lock for YSL-style pager
 * Locks document scroll while the section pager owns the wheel.
 */
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { FAIR_HOME_V2_SCROLL_ROOT_CLASS } from './fair-home-v2-scroll.data'

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function useFairHomeV2Scroll() {
  const reducedMotion = ref(prefersReducedMotion())
  let motionQuery: MediaQueryList | null = null

  function applyPagerLock(enabled: boolean) {
    document.documentElement.classList.toggle(
      `${FAIR_HOME_V2_SCROLL_ROOT_CLASS}--pager`,
      enabled,
    )
    document.body.style.overflow = enabled ? 'hidden' : ''
  }

  function onMotionChange(event: MediaQueryListEvent) {
    reducedMotion.value = event.matches
    applyPagerLock(!event.matches)
  }

  onMounted(() => {
    document.documentElement.classList.add(FAIR_HOME_V2_SCROLL_ROOT_CLASS)
    applyPagerLock(!reducedMotion.value)

    motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    motionQuery.addEventListener('change', onMotionChange)
  })

  onBeforeUnmount(() => {
    motionQuery?.removeEventListener('change', onMotionChange)
    document.documentElement.classList.remove(FAIR_HOME_V2_SCROLL_ROOT_CLASS)
    document.documentElement.classList.remove(
      `${FAIR_HOME_V2_SCROLL_ROOT_CLASS}--pager`,
    )
    document.body.style.overflow = ''
  })

  return { reducedMotion }
}
